import { render, staticRenderFns } from "./LogBox.vue?vue&type=template&id=daa705de&scoped=true&"
import script from "./LogBox.vue?vue&type=script&lang=js&"
export * from "./LogBox.vue?vue&type=script&lang=js&"
import style0 from "./LogBox.vue?vue&type=style&index=0&id=daa705de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa705de",
  null
  
)

export default component.exports